import { useEffect, useState } from "react"
import { useCentralStore } from "../../../store/appContext"
import SalesBusinessReport from "./SalesBusinessReport"
import SalesReportData from "./SalesReportData"
import ActionTypes from "../../../store/actionTypes"
import API from "../../../api"
import resources from '../../../components/common/resources.json'

const SalesReportContainer = () => {
    const [{ projectName, selectedTab, userData, userDetails, reportFilterDuration, saleMonthlyTrendData, salesBusinessData }, dispatch] = useCentralStore()
    // let x = {"SalesBusinessReportResponse":{"salesBusinessReport":[{"ClientName":"celcom","Months":"202408","GrossAdd":10341,"Renewal":3430,"Chrun":6253,"NetAdd":3975}],"salesBusinessChurnClosingReport":[{"Months":"202408","ChurnRate":625300,"ClosingBase":1}],"salesTrainingReport":[{"Months":"2024-08","TrainingCategory":"New Joiner","Volume":1}]}}
    // let chartData = {"SalesBusinessReportResponse":{"salesTrainingMonthlyReport":[{"Months":"2024-08","TrainingCategory":"New Joiner","Volume":1},{"Months":"2024-01","TrainingCategory":"New Joiner","Volume":1},{"Months":"2024-05","TrainingCategory":"New Joiner","Volume":1}],"salesBusinessReportMonthlyTrend":[{"ClientName":"celcom","Months":"202401","GrossAdd":9513,"Renewal":3541,"Chrun":8655,"NetAdd":853},{"ClientName":"celcom","Months":"202402","GrossAdd":9379,"Renewal":3536,"Chrun":7624,"NetAdd":1754},{"ClientName":"celcom","Months":"202403","GrossAdd":9927,"Renewal":3650,"Chrun":56002,"NetAdd":-46081},{"ClientName":"celcom","Months":"202404","GrossAdd":9459,"Renewal":3271,"Chrun":7064,"NetAdd":2398},{"ClientName":"celcom","Months":"202405","GrossAdd":11311,"Renewal":3628,"Chrun":7549,"NetAdd":3763},{"ClientName":"celcom","Months":"202406","GrossAdd":10625,"Renewal":2990,"Chrun":6832,"NetAdd":3792},{"ClientName":"celcom","Months":"202407","GrossAdd":10339,"Renewal":2944,"Chrun":7169,"NetAdd":3168},{"ClientName":"celcom","Months":"202408","GrossAdd":10341,"Renewal":3430,"Chrun":6253,"NetAdd":3975},{"ClientName":"celcom","Months":"202409","GrossAdd":12290,"Renewal":3612,"Chrun":4586,"NetAdd":7998},{"ClientName":"celcom","Months":"202410","GrossAdd":14677,"Renewal":4791,"Chrun":8012,"NetAdd":6884},{"ClientName":"celcom","Months":"202411","GrossAdd":14822,"Renewal":4331,"Chrun":7941,"NetAdd":6979},{"ClientName":"celcom","Months":"202412","GrossAdd":17634,"Renewal":3934,"Chrun":8508,"NetAdd":9132},{"ClientName":"celcom","Months":"202501","GrossAdd":10393,"Renewal":2135,"Chrun":6012,"NetAdd":4052}],"salesBusinessChurnClosingMonthlyTrend":[{"Months":"202401","ChurnRate":2.06,"ClosingBase":421007},{"Months":"202402","ChurnRate":1.81,"ClosingBase":421007},{"Months":"202403","ChurnRate":13.3,"ClosingBase":421007},{"Months":"202404","ChurnRate":1.68,"ClosingBase":421007},{"Months":"202405","ChurnRate":1.79,"ClosingBase":421007},{"Months":"202406","ChurnRate":1.62,"ClosingBase":421007},{"Months":"202407","ChurnRate":1.7,"ClosingBase":421007},{"Months":"202408","ChurnRate":1.49,"ClosingBase":421007},{"Months":"202409","ChurnRate":1.09,"ClosingBase":421007},{"Months":"202410","ChurnRate":1.9,"ClosingBase":421007},{"Months":"202411","ChurnRate":1.89,"ClosingBase":421007},{"Months":"202412","ChurnRate":2.02,"ClosingBase":421007},{"Months":"202501","ChurnRate":1.43,"ClosingBase":421007}]}}

    // const [salesReportTableData, setSalesReportTableData] = useState(x?.SalesBusinessReportResponse)
    const [salesReportData, setSalesReportData] = useState([])
    // const [previousDuration, setPreviousDuration] = useState(reportFilterDuration?.duration);

    // const hasStateUpdated = (previousState, currentState) => {
    //     return previousState !== currentState;
    // };
    
    const setLoading = (action) => {
        dispatch({ type: ActionTypes.SET_LOADING, payload: action });
      };

    //   useEffect(() => {
    //     if(selectedTab !== 'Monthly Trends') {
    //     if (hasStateUpdated(previousDuration, reportFilterDuration?.duration)) {
    //         console.log("State has updated");
    //         setPreviousDuration(reportFilterDuration?.duration);
    //         let payload = {
    //             ReportMonth: reportFilterDuration?.duration?.replace('-', ''),
    //             ReportType: selectedTab === 'Monthly Trends' ? 'monthly trend' : "business"
    //         }
    //         setLoading(true);
    //         API[ActionTypes.GET_SALES_BUSINESS_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
    //             .then(({ data }) => {
    //                 setLoading(false);
    //                 if (data) {
    //                     setSalesReportData(data?.SalesBusinessReportResponse)
    //                     dispatch({ type: ActionTypes.SALES_REPORT_BUSINESS_DATA, payload: data?.SalesBusinessReportResponse })
    //                 }
    //             })
    //             .catch((err) => {
    //                 setLoading(false);
    //                 dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
    //                 let _payload = {
    //                     level: resources.POST_LOGGER_ERROR,
    //                     category: resources.POST_LOGGER_API,
    //                     ApiName: resources.POST_LOGGER_APINAME,
    //                     message: {
    //                         error: err,
    //                         info: {
    //                             idToken: "",
    //                         },
    //                     },
    //                 };
    //                 API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
    //             });
    //     } else {
    //         console.log("State has not updated");
    //         setSalesReportData(salesBusinessData)
    //     }
    // } else {
    //     setSalesReportData(saleMonthlyTrendData)
    // }
    // }, [selectedTab, reportFilterDuration?.duration]);

    useEffect(() => {
        if (selectedTab && reportFilterDuration?.duration) {
            let payload = {
                ReportMonth: reportFilterDuration?.duration?.replace('-', ''),
                ReportType: selectedTab === 'Monthly Trends' ? 'monthly trend' : "business"
            }
            setLoading(true);
            API[ActionTypes.GET_SALES_BUSINESS_REPORT](payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0])
                .then(({ data }) => {
                    setLoading(false);
                    if (data) {
                        setSalesReportData(data?.SalesBusinessReportResponse)
                    }
                })
                .catch((err) => {
                    setLoading(false);
                    dispatch({ type: ActionTypes.SET_API_ERROR, data: true });
                    let _payload = {
                        level: resources.POST_LOGGER_ERROR,
                        category: resources.POST_LOGGER_API,
                        ApiName: resources.POST_LOGGER_APINAME,
                        message: {
                            error: err,
                            info: {
                                idToken: "",
                            },
                        },
                    };
                    API[ActionTypes.POST_LOGGER](_payload, userData?.access_token, userDetails && userDetails?.email?.split("@")?.[0]);
                });
        } 
        // else {
        //     setSalesReportData(saleMonthlyTrendData)
        // }
    }, [selectedTab, reportFilterDuration?.duration])

    return (
        <div>
            {(projectName === "Sales Report" && selectedTab === 'Prev Month') &&
                <SalesReportData salesReportData={salesReportData} />
            }
            {projectName === "Sales Report" && selectedTab ==="Monthly Trends" &&
                <SalesBusinessReport salesReportData={salesReportData} />
            }
        </div>
    )
}

export default SalesReportContainer